import MonterGenerator from './generator';
export default class Monster {
    constructor(code = null, level = 1) {
        this.code = code;
        this.level = level;
        /**
         * Temporary
         */
        this.buffs = [];
        this.debuffs = [];
        this.statChanges = [];
        this.init();
    }
    static breed(mainMonster, secondaryMonster) {
        return null;
    }
    static levelUp(monster) {
        return null;
    }
    static evolve(monster) {
        return null;
    }
    get serialized() {
        return {
            baseAttributes: this.baseAttributes,
            gender: this.gender,
            type: this.type,
            subType: this.subType,
            moves: this.moves.map(({ name, description, type, power, manaCost, }) => ({
                name: type ? `${name} (${type})` : name,
                description: power ? `(${manaCost} Mana) ${description}. Deals ${power} damage to target(s)` : `(${manaCost} Mana) ${description}`
            })),
            numMoves: this.numMoves,
            traits: this.traits.map(({ name, description }) => ({ name, description })),
            geneticStrength: this.geneticStrength,
            canEvolve: this.canEvolve,
        };
    }
    init() {
        if (!this.code) {
            this.code = MonterGenerator.generateCode();
        }
        this.buildFromCode();
    }
    buildFromCode() {
        const { baseAttributes, gender, type, subType, moves, numMoves, traits, geneticStrength, canEvolve, } = MonterGenerator.generateFromCode(this.code, this.level);
        this.baseAttributes = baseAttributes;
        this.gender = gender;
        this.type = type;
        this.subType = subType;
        this.moves = moves;
        this.numMoves = numMoves;
        this.traits = traits;
        this.geneticStrength = geneticStrength;
        this.canEvolve = canEvolve;
    }
}
/*
    Attributes
    ----------
    Health
    Mana
    Attack
    Magic
    Speed
    Defense
    Luck

    Qualities
    ---------
    Gender
    Type
    SubType
    NumTraits
    NumMoves

    Types
    -----
    Water (strong vs Fire)
    Fire (strong vs Earth)
    Earth (strong vs Electric, immune to Electric)
    Electric (strong vs Water)

    Flying (immune to physical, immune to Earth)
    Physical

    Traits
    ------
    - Durable: Take half damage from physical attacks, but can never dodge
    - Stubborn: Take [2-3]x damage from all sources, when knocked out, gain full life at the beginning of the following turn, and automatically moves first.
    - Hard Hitting: Deal double physical damage, but misses half the time
    - Endless Mana: Creature's mana pool is cut in half. Every turn, replenish mana pool
    - Buff sharing: All buffs and debuffs to this creature are shared with the rest of the party

    Moves
    -----
    - [Water, Fire, Earth, Electric, Flying, Physical] All
    - [Water, Fire, Earth, Electric, Flying, Physical] Single
    - [Water, Fire, Earth, Electric, Flying, Physical] Debuff
    - [Atk, Mag, Def, Speed, Luck, Health, Mana] Up
    - [Atk, Mag, Def, Speed, Luck, Health, Mana] Down
    - [Multi-Strike, Reflect, Wall]
*/ 
